import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IconArrowHead } from '../../components';

import css from './Accordion.module.css';

const AccordionItem = ({ title, children, isOpen, onToggle }) => {
  return (
    <div className={css.accordionItem}>
      <button
        className={classNames(css.accordionButton, { [css.open]: isOpen })}
        onClick={onToggle}
        type="button"
      >
        <span className={css.accordionTitle}>{title}</span>
        <IconArrowHead
          direction={isOpen ? 'up' : 'down'}
          size="small"
          rootClassName={css.arrowIcon}
        />
      </button>
      {isOpen && (
        <div className={css.accordionContent}>
          <div className={css.accordionContentInner}>{children}</div>
        </div>
      )}
    </div>
  );
};

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

const Accordion = ({ children, allowMultiple = false, className }) => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const handleToggle = index => {
    if (allowMultiple) {
      setOpenIndexes(prev =>
        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
      );
    } else {
      setOpenIndexes(prev => (prev.includes(index) ? [] : [index]));
    }
  };

  const classes = classNames(css.accordion, className);

  return (
    <div className={classes}>
      {React.Children.map(children, (child, index) => {
        if (child.type !== AccordionItem) {
          return child;
        }
        return React.cloneElement(child, {
          isOpen: openIndexes.includes(index),
          onToggle: () => handleToggle(index),
        });
      })}
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  allowMultiple: PropTypes.bool,
  className: PropTypes.string,
};

export { Accordion, AccordionItem };
